export const LOAD_PROPERTIES = 'LOAD_PROPERTIES';
export const SET_PROPERTY_PAGINATION = 'SET_PROPERTY_PAGINATION';
export const SET_PROPERTY_SORT = 'SET_PROPERTY_SORT';
export const ADD_NEW_PROPERTY = 'ADD_NEW_PROPERTY';
export const UPDATE_TRANSLATE_PROPERTY = 'UPDATE_TRANSLATE_PROPERTY';
export const ADD_PROPERTY_VALUE_TO_PROPERTY = 'ADD_PROPERTY_VALUE_TO_PROPERTY';
export const EDIT_PROPERTY_VALUE_TO_PROPERTY = 'EDIT_PROPERTY_VALUE_TO_PROPERTY';
export const LOAD_EDITABLE_PROPERTY = 'LOAD_EDITABLE_PROPERTY';
export const SET_EMPTY_EDITABLE_PROPERTY = 'SET_EMPTY_EDITABLE_PROPERTY';
export const EDIT_PROPERTY = 'EDIT_PROPERTY';
export const EDIT_PROPERTY_FORM_CARRIERS = 'EDIT_PROPERTY_FORM_CARRIERS';
export const GO_TO_STEP_OF_PROPERTY_FORM = 'GO_TO_STEP_OF_PROPERTY_FORM';
export const SET_PROPERTY_FILTER = 'SET_PROPERTY_FILTER';
export const SET_PROPERTY_TYPE_FILTER = 'SET_PROPERTY_TYPE_FILTER';
export const LOAD_PROPERTY_VALUES = 'LOAD_PROPERTY_VALUES';
export const SET_PROPERTY_VALUES_FILTERS = 'SET_PROPERTY_VALUES_FILTERS';
export const SET_PROPERTY_VALUES_PAGINATION = 'SET_PROPERTY_VALUES_PAGINATION';
export const RESET_FILTER_PROPERTIES = 'RESET_FILTER_PROPERTIES';
export const LOAD_PROPERTY_FOR_EDITING_PROPERTY_VALUES = 'LOAD_PROPERTY_FOR_EDITING_PROPERTY_VALUES';
export const SET_SELECTED_PROPERTY = 'SET_SELECTED_PROPERTY';
export const SET_EDITABLE_PROPERTY_VALUE = 'SET_EDITABLE_PROPERTY_VALUE';
export const DELETE_PROPERTY_VALUE = 'DELETE_PROPERTY_VALUE';
